import Vue from "vue";
import { Street } from "./street";

export class Cliente {
    static create() {
        return {
            nome: null,
            street: Street.create(),
            telefones: [],
            tipo_cliente: "f",
            cpf_cnpj: null,
            razao_social: null
        };
    }

    /**
     *
     * @return {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("cliente/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("clientes")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("clientes", data);
            } else {
                promisse = Vue.http.post("clientes", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
